import { Sans } from "../util/sdk";

export async function reportErrorToNR(error: string | Error, meta: Record<string, unknown> = {}) {
  const userId = await Sans.sdk.getUserId();
  console.log("Sending error:", error, meta, userId);
  window.newrelic.noticeError(error, { ...meta, userId });
}
